module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_SL-513e90b8535db0f1e2e687a9ab8e40a7.svg";